import { Button, Tooltip } from '@mui/material'
import React, { useState } from 'react'

import { useIsMobile } from '@/app/hooks/use-is-mobile'
import FeedbackDialog from '@/app/module/user/component/feedback-dialog'

const FeedbackButton: React.FC = () => {
  const isMobile = useIsMobile()

  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <>
      <Tooltip title="Send Feedback">
        <Button
          id="header-feedback-trigger"
          color="inherit"
          size={isMobile ? 'small' : 'medium'}
          variant="outlined"
          onClick={handleOpen}
        >
          Feedback
        </Button>
      </Tooltip>
      <FeedbackDialog open={open} onClose={handleClose} />
    </>
  )
}

export default FeedbackButton
